import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
`;

export const PromotionBadge = styled.span`
  display: inline-block;
  align-self: flex-end;
  background: ${colors.sale};
  color: ${colors.white};
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  padding: 4px 10px;
  border-radius: 4px;
  letter-spacing: 0.2px;
`;

export const Title = styled.h1`
  font-family: ${fonts.heading};
  font-size: ${fonts.size['2xl']};
  font-weight: ${fonts.weight.bold};
  color: ${colors.fontPrimary};
  margin: ${space[2]} 0 0;
  line-height: 1.3;
`;

export const PriceRow = styled.div`
  margin-top: ${space[4]};
`;

export const FieldLabel = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
  margin: 0 0 ${space[3]};
`;

export const Section = styled.div`
  margin-top: ${space[6]};
`;

export const OptionsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(96px, 1fr));
  gap: ${space[3]};
`;

export const FulfilmentRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${space[3]};
  margin-top: ${space[6]};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${colors.fontSecondary};
`;

export const FulfilmentItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${space[2]};

  svg {
    color: ${colors.fontPrimary};
  }
`;

export const FulfilmentSeparator = styled.span`
  color: ${colors.black};
`;

export const DescriptionSection = styled.div`
  margin-top: ${space[6]};
`;

export const SpecificationsSection = styled.div`
  margin-top: ${space[5]};
`;

export const ButtonSection = styled.div`
  flex-shrink: 0;
  position: fixed;
  bottom: calc(56px + env(safe-area-inset-bottom, 0px));
  left: 0;
  right: 0;
  padding: ${space[4]};
  background: ${colors.white};
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
  z-index: 99;

  @media (min-width: ${layout.desktopBreakpoint}) {
    position: static;
    bottom: auto;
    padding: 0;
    padding-top: ${space[5]};
    background: none;
    box-shadow: none;
    z-index: auto;
  }
`;
